module.exports = __webpack_public_path__ + "img/pleasewait.900fe0b2.png";